import React, { useCallback } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import _isNil from "lodash/isNil";
import CardComponent from "../CardComponent";
import { ReactComponent as HeartFilledIcon } from "../../assets/heart-icon.svg";
import {
  TournamentStatus,
  WidgetItem,
} from "../../interfaces/TournamentsConfig";
import { getTournamentCurrentStatus } from "../../utils/helpers/TournamentNXUtils";
import { useNavigate } from "react-router-dom";
import { NAVIGATION_ROUTES } from "../../constant";
import { useTranslation } from "react-i18next";

interface ChancesLeftCardProps {
  tournament: WidgetItem;
}
const ChancesLeftCard: React.FC<ChancesLeftCardProps> = ({
  tournament,
}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const { playingAttempt = 0, maxPlayingAttempt= 0, } = tournament || {};
  const tournamentStatus = getTournamentCurrentStatus(tournament);

  const actualAttemptLeft =  maxPlayingAttempt - playingAttempt;

  const isTournamentLive = useCallback(() => {
    if (
      tournamentStatus === TournamentStatus.TOURNAMENT_LIVE_USER_NOT_ENTERED ||
      tournamentStatus ===
        TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING ||
      tournamentStatus ===
        TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_NOT_REMAINING
    ) {
      return true;
    }
    return false;
  }, [tournamentStatus]);



  // if (playingAttempt >= maxPlayingAttempt || !isTournamentLive()) {
  //   const navigateToLobby = useCallback(() => {
  //     navigate(NAVIGATION_ROUTES.HOME, {
  //       gameName: gameName
  //     })
  //   }, []);
  // }

  if (_isNil(playingAttempt) || _isNil(maxPlayingAttempt)) {
    return null;
  }
  return (
    <>
      <CardComponent className={clsx(styles.chancesLeftCard)} borderType="Sm">
        <div className={clsx(styles.chancesLeftBox)}>
          <HeartFilledIcon />
          <div
            className={clsx(styles.chancesLeft, "fontSizeSm14 fontWeightBold")}
          >
            {/* {actualAttemptLeft} out of {maxPlayingAttempt} entries left */}
            {t("entriesLeft",{maxPlayingAttempt , actualAttemptLeft})}
          </div>
        </div>
      </CardComponent>
    </>
  );
};
export default ChancesLeftCard;
